import React from 'react';
import PropTypes from 'prop-types';
import { colorPalette as colors } from '../colors';

const LoaderCircular = ({
  color,
  size = 10,
  thickness,
  className = '',
  style = {}
}) => {
  const loaderStyle = {
    borderTopColor: colors[color],
    width: size,
    height: size,
    borderWidth: thickness
  };
  return /*#__PURE__*/React.createElement("div", {
    className: `loaderCircular ${className}`,
    width: size,
    height: size,
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    style: { ...loaderStyle
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: { ...loaderStyle
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: { ...loaderStyle
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: { ...loaderStyle
    }
  }));
};

LoaderCircular.defaultProps = {
  color: 'primary',
  size: 14,
  thickness: 2
};
LoaderCircular.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};
export default LoaderCircular;